import { render, staticRenderFns } from "./ServicePublicMoney.vue?vue&type=template&id=11d78ebc&scoped=true&"
import script from "./ServicePublicMoney.vue?vue&type=script&lang=ts&"
export * from "./ServicePublicMoney.vue?vue&type=script&lang=ts&"
import style0 from "./ServicePublicMoney.vue?vue&type=style&index=0&id=11d78ebc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d78ebc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
